module.exports = __webpack_public_path__ + "static/desktop/img/marketplace.29d81e50.png";